<template>
    <div>
        <ul class="wrapper">
            <li>
                <Carousel autoplay v-model="swiperVal" loop :autoplay-speed="3000">
                    <CarouselItem v-for="(item, index) in imgList" :key="index">
                        <img class="imgs" :src="item.imgUrl" @click="onClickPoster(item)" />
                    </CarouselItem>
                </Carousel>
            </li>
            <li>
                <div class="myEcharts">
                    <div class="myBtn" @click="queryLarge">大图</div>
                    <!-- PP/PE 折线图 -->
                    <echarts />
                </div>
            </li>
        </ul>
        <div style="margin-top: 50px; text-align: center">
            <img style="width: 1080px" :src="localUtil.imgUrl + 'home/service-desc.png'" />
        </div>
        <!-- 托盘专区 -->
        <div style="margin-top:50px">
            <shelf />
        </div>
        <h2 style="margin-top:50px">荣誉资质</h2>
        <honor-credential />
        <!-- <h2 style="margin-top:50px">合作伙伴</h2>
        <div style="margin: 15px 0 95px 0">
            <img style="width: 1080px; height: 300px" :src="localUtil.imgUrl + '/home/partner.png'" />
        </div> -->
        <div class="qrCode" @click="onQrcode" v-if="qrCodeShow">
            <div>X</div>
            <p>微信移动商城</p>
            <img src="https://plt-official-site-1254134783.cos.ap-shenzhen-fsi.myqcloud.com/desktop-client/mall/mp-mall.jpg" alt="网格九脚注塑托盘，周转筐,铁耳筐,托盘租赁,双面吹塑托盘">
        </div>
        <!-- 查看大图echarts -->
        <max-echarts ref="maxEchartsRef" />
    </div>
</template>
<script>
import shelf from './shelf';
import echarts from './echarts'
import honorCredential from './honorCredential'
import maxEcharts from './maxEcharts'
export default {
    name: "homePage",
    components: { shelf, echarts, honorCredential, maxEcharts },
    data() {
        return {
            swiperVal: 0,
            imgList: [],
            qrCodeShow:true
        }
    },
    mounted() {
        let param = {
            url: 'http://MID-CLIENT-MALL/messageService/websiteService/queryValidPosterList',
        }
        this.invoke(param).then(rs => {
            this.imgList = rs;
        })
    },
    methods: {
        onQrcode(){
            this.qrCodeShow = !this.qrCodeShow;
        },
        onClickPoster(poster) {
            if (poster.router) {
                let routeData = this.$router.resolve({
                    path: poster.router,
                    query: JSON.parse(poster.routerParam)
                })

                window.open(routeData.href, '_blank');
            }
        },
        queryLarge() {
            this.$refs['maxEchartsRef'].openModal()
        }
    }

}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1200px) {
    .qrCode{display: none;}
}
.qrCode{
    width: 109px;
    height: 150px;
    background: #ff9000;
    border-radius: 3px;
    position: fixed;
    right: 70px;
    bottom: 50px;
    z-index: 10;
    text-align: center;
    color: #FFF;
    &:hover >div{
        display: block;
    }
    >div{
        position: absolute;
        right: 1px;
        top: 1px;
        width: 18px;
        height:18px;
        border-radius: 50%;
        border: 1px solid #FFF;
        text-align: center;
        line-height: 18px;
        font-size: 12px;
        display: none;
        &:hover{
            cursor: pointer;
            transform: rotateZ(180deg);
            transition: all .5s;
        }
    }
    p{
        margin-top: 17px;
    }
        img{
            margin-top: 3px;
            width:100px;
            height:100px;
        }
    
}
.wrapper {
    margin-top: 20px;
    list-style: none;
    height: 255px;
    li {
        height: 255px;
        .myEcharts {
            width: 370px;
            height: 225px;
            position: relative;
            .myBtn {
                height: 25px;
                background: #2db7f5;
                border-radius: 3px;
                line-height: 25px;
                text-align: center;
                position: absolute;
                padding: 0 5px;
                color: #fff;
                top: -2px;
                left: 50px;
                z-index: 2;
                cursor: pointer;
                &:hover {
                    opacity: 0.8;
                }
            }
        }
    }

    li:first-child {
        width: 700px;
        float: left;
        overflow: hidden;

        .imgs {
            width: 700px;
            height: 252px;
            &:hover {
                cursor: pointer;
            }
        }
    }
    li:nth-child(2) {
        text-align: center;
    }
    li:last-child {
        float: left;
        margin: 0 0 0 5px;
        width: 370px;
        height: 292px;
    }
}
</style>